import { useEffect, useState } from 'react'
import { fetchApi } from '../../db/api.js'

export default function FeedAudio({ attachment, clientId }) {
  const [url, setUrl] = useState(null)
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)

  useEffect(() => {
    const controller = new AbortController()
    setUrl(null)
    setError(false)
    if (!clientId) { setError(true); return }
    fetchApi(`/atendimento/attachments/${encodeURIComponent(attachment.id)}/download?client_id=${encodeURIComponent(clientId)}`, { signal: controller.signal })
      .then(data => { if (!controller.signal.aborted) { if (data.url) setUrl(data.url); else setError(true) } })
      .catch(() => { if (!controller.signal.aborted) setError(true) })
    return () => controller.abort()
  }, [attachment.id, clientId, retry])

  return <div className="dashboard-feed-audio">
    {url && !error && <audio controls preload="none" src={url} aria-label={attachment.nome || 'Mensagem de áudio'} onError={() => setError(true)} />}
    {!url && !error && <span role="status">Carregando áudio…</span>}
    {error && <><span role="status">Não foi possível carregar o áudio.</span><button type="button" className="dashboard-task-link" onClick={() => setRetry(value => value + 1)}>Tentar novamente</button></>}
  </div>
}
